import { BaseService } from "./base.service";
import { IScopeOfWork, IScopeOfWorkGridDetail } from "models/ScopeOfWorkModel";

class ScopeOfWorkServiceInternal extends BaseService {
	getScopeOfWorkList = async (): Promise<IScopeOfWork[]> =>
		this.callApi<IScopeOfWork[]>(`ScopeOfWork/GetAll`, "GET");

	saveUpdateScopeOfWorkDetail = async (
		model: IScopeOfWorkGridDetail[]
	): Promise<number> =>
		this.callApi<number>(`ScopeOfWork/SaveUpdate`, "POST", undefined, model);

	getScopeOfWorkGridList = async (): Promise<IScopeOfWorkGridDetail[]> =>
		this.callApi<IScopeOfWorkGridDetail[]>(
			`ScopeOfWork/GetScopeOfWorkList`,
			"POST"
		);
}

export const ScopeOfWorkService = new ScopeOfWorkServiceInternal();
